import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SessionStaffing } from './staffing.model';

@Injectable()
export class SessionStaffingService {
    constructor(private http: HttpClient) {}

    findOneVirtualSession(virtualSessionId): Observable<SessionStaffing> {
        return this.http.get<SessionStaffing>(
            '/api/virtual-sessions/' + virtualSessionId
        );
    }

    edit(updatedVirtualSession: SessionStaffing) {
        return this.http.put('/api/virtual-sessions/', updatedVirtualSession);
    }

    create(newVirtualSession: SessionStaffing): Observable<any> {
        return this.http.post<any>('/api/virtual-sessions/', newVirtualSession);
    }

    getTrainersResponses(id): Observable<any> {
        return this.http.get<any>(
            '/api/sessions/virtual/' + id + '/trainers-proposals'
        );
    }

    proposeVirtualSessionToTrainers(id, trainersId): Observable<any> {
        return this.http.post(
            '/api/sessions/virtual/' + id + '/trainers-proposals',
            trainersId
        );
    }

    findAll(): Observable<SessionStaffing[]> {
        return this.http.get<SessionStaffing[]>('/api/virtual-sessions/');
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/session/staffing/staffing.service.ts